import { SET_HBL_CONFIG, donationConstants, SET_TAX_DONATION_MESSAGES, SET_RECURRING_DEFAULT_OPTIONS, SET_NONRECURRING_DEFAULT_OPTIONS, SET_DEFAULT_AMOUNT_OPTIONS } from '../actionTypes';

const initialState = {
  donation: [],
  transaction: [],
  product_impact: '',
  show_product_impact: '',
  user_id: '',
  fundraiser_page_id: '',
  team_member_id: '',
  currency_id: '',
  donation_rebate_id: '',
  product_id: '',
  donation_amount: 0,
  is_anonymous: '',
  donations_paginate_by_user: {},
  hbl_config_data: '',
  is_hbl_config_data: false,
  payment_methods: '',
  banks_list: '',
  user_profile_details: '',
  redux_loader: false,
  if_giftaid: '',
  intent_client_secret: '',
  hblConfig: {},
  checkoutMessages: {
    donation_message: null,
    taxes_message: null,
  },
  partnerLogo: null
};

export function donation(state = initialState, action) {
  switch (action.type) {
    case SET_HBL_CONFIG:
      return {
        ...state,
        hblConfig: action.response
      }
    case SET_TAX_DONATION_MESSAGES:
      return {
        ...state,
        checkoutMessages: action.response,
        partnerLogo: action.response.logo
      }
    case donationConstants.DONATE_TO_CAMPAIGN:
      return state;
    case 'PRODUCT_IMPACT':
      return {
        ...state,
        product_impact: action.product_impact
      };
    case 'SHOW_PRODUCT_IMPACT':
      return {
        ...state,
        show_product_impact: action.show_product_impact
      };
    case 'UPDATE_LOADER_STATE':
      state.redux_loader = action.loader_state;
      return {
        ...state
      };

    default:
      return state
  }
}

export function donations_by_user(state = {}, action) {
  switch (action.type) {
    case donationConstants.DONATE_TO_CAMPAIGN:
      return state;
    case 'DONATIONS_BY_USER':
      return {
        ...state,
        donations_by_user: action.donations_by_user
      };
    default:
      return state
  }
}

export function donations_paginate_by_user(state = {}, action) {
  switch (action.type) {
    case 'DONATIONS_PAGINATE_BY_USER':
      return {
        ...state,
        donations_paginate_by_user: action.donations_paginate_by_user
      };
    default:
      return state
  }
}

export function latest_donations_by_user(state = {}, action) {
  switch (action.type) {
    case donationConstants.DONATE_TO_CAMPAIGN:
      return state;
    case 'LATEST_DONATIONS_BY_USER':
      return {
        ...state,
        latest_donations_by_user: action.latest_donations_by_user
      };
    default:
      return state
  }
}

export function currencies(state = initialState, action) {
  switch (action.type) {
    case 'FETECHED_ALL_CURRENCIES':
      return {
        //...state,
        currencies: action.currencies
      };
    default:
      return state
  }
}

export function donation_rebates(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_DONATION_REBATES':
      return {
        //...state,
        donation_rebates: action.donation_rebates
      };
    default:
      return state
  }
}

export function hbl_config_data(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_HBL_CONFIG_DATA':
      state.is_hbl_config_data = true;
      return {
        ...state,
        hbl_config_data: action.hbl_config_data
      };
    default:
      return state
  }
}

export function payment_methods(state = initialState, action) {
  switch (action.type) {
    case 'GET_PAYMENT_METHODS':
      return {
        // ...state,
        payment_methods: action.payment_methods
      };
    case 'STRIPE_INTENT_SECRET':
      return {
        ...state,
        intent_client_secret: action.intent_client_secret
      };
    default:
      return state
  }
}

export function check_if_country_has_giftaid(state = initialState, action) {
  switch (action.type) {
    case 'CHECK_IF_GIFTAID':
      return {
        // ...state,
        if_giftaid: action.if_giftaid
      };
    default:
      return state
  }
}

export function isCountryCorporateMatch(state = initialState, action) {
  switch (action.type) {
    case 'CHECK_IF_CORPORATE_MATCH':
      return {
        // ...state,
        if_corporate_match: action.if_corporate_match
      };
    default:
      return state
  }
}

export function check_if_country_partner_isactive_for_fundraiser(state = initialState, action) {
  switch (action.type) {
    case 'CHECK_IF_COUNTRY_PARTNER_ACTIVE_FOR_FUNDRAISER':
      return {
        // ...state,
        if_partner_active_for_fundraiser: action.if_partner_active_for_fundraiser
      };
    default:
      return state
  }
}

export function check_if_country_partner_isactive_for_donor(state = initialState, action) {
  switch (action.type) {
    case 'CHECK_IF_COUNTRY_PARTNER_ACTIVE_FOR_DONOR':
      return {
        // ...state,
        if_partner_active_for_donor: action.if_partner_active_for_donor
      };
    default:
      return state
  }
}

export function banks_list(state = initialState, action) {
  switch (action.type) {
    case 'GET_BANKS_LIST':
      return {
        // ...state,
        banks_list: action.banks_list
      };
    default:
      return state
  }
}

export function user_profile_details(state = initialState, action) {
  switch (action.type) {
    case 'GET_USER_PROFILE_DETAILS':
      return {
        // ...state,
        user_profile_details: action.user_profile_details
      };
    default:
      return state
  }
}

export function updateDonationDetails(state = initialState, action) {
  switch (action.type) {
    case 'GET_DONATION_DETAILS':
      return {
        ...state,
        donation_details: action.donation_details
      };
    default:
      return state
  }
}

export function currencyDefaultAmountOptions(state = {recurring: [], nonRecurring: []}, action) {
  switch (action.type) {
    case SET_DEFAULT_AMOUNT_OPTIONS:
      return {
        recurring: action.recurring,
        nonRecurring: action.nonRecurring
      };
    default:
      return state
  }
}